import React, { useEffect, useState } from 'react';
import { MDBContainer, MDBCard, MDBCardBody, MDBCardTitle, MDBCardText, MDBBtn } from 'mdb-react-ui-kit';
import axios from 'axios';
import config from '../auth_config.json'; // Import the configuration

const Sso = () => {
  const [ticketUrl, setTicketUrl] = useState('');

  const fetchSsoTicket = async () => {
    const token = config.bearerToken; // Access the bearer token from the config

    const data = {
      connection_config: {
        name: '3M', //change this each time you create a new connection
      },
      enabled_clients: [`${config.clientId}`],
    };

    const apiConfig = {
      method: 'post',
      url: `https://${config.domain}/api/v2/self-service-profiles/${config.sso_id}/sso-ticket`, // Use the domain from the config
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`, // Use the token from the config
      },
      data: JSON.stringify(data),
    };

    try {
      const response = await axios.request(apiConfig);
      console.log('Response Data:', response.data); // Log the response data
      
      // Extract the URL from the response
      if (response.data && response.data.ticket) {
        setTicketUrl(response.data.ticket); // Set the ticket URL
      } else {
        console.error('Ticket URL not found in response');
      }
    } catch (error) {
      console.error('Error fetching SSO ticket:', error);
    }
  };

  return (
    <MDBContainer className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
      <MDBCard style={{ maxWidth: '22rem', margin: '0 10px' }}>
        <MDBCardBody>
          <MDBCardTitle>Self SSO Example</MDBCardTitle>
          <MDBCardText>
            Click the button below to access the self-service SSO.
          </MDBCardText>
          <MDBBtn color="primary" onClick={fetchSsoTicket}>Self SSO</MDBBtn>
          {ticketUrl && (
            <MDBCardText className="mt-3">
              Ticket URL: 
              <span style={{ display: 'block', marginTop: '5px' }}>
                <a href={ticketUrl} target="_blank" rel="noopener noreferrer">{ticketUrl}</a>
              </span>
            </MDBCardText>
          )}
        </MDBCardBody>
      </MDBCard>
    </MDBContainer>
  );
};

export default Sso;
